<template>
  <div class="container" style="background-color: #fff">
    <headerBox></headerBox>
    <bannerBox ref="bannerChild"></bannerBox>
    <div class="content_box">
      <div class="content_box2" style="overflow-x: scroll">
        <div style="min-width: 950px">
          <div class="common_info">
            <div class="info_left">
              <Form ref="uform" :label-width="120" :model="vipInfo">
                <FormItem label="单位名称">
                  <Input v-model="vipInfo.dwmc" readonly></Input>
                </FormItem>
                <FormItem label="统一社会信用代码">
                  <Input v-model="vipInfo.uscc" readonly></Input>
                </FormItem>
                <FormItem label="企业法人">
                  <Input v-model="vipInfo.frxm" readonly></Input>
                </FormItem>
                <FormItem label="会员类型">
                  <Input v-model="vipInfo.type" readonly></Input>
                </FormItem>
                <FormItem label="单位地址">
                  <Input v-model="vipInfo.txdz" readonly></Input>
                </FormItem>
              </Form>
            </div>
            <div class="info_right">
              <img
                v-if="vipInfo.resource"
                :src="$previewImg + vipInfo.resource"
                width="260px"
              />
            </div>
          </div>
          <div v-if="!vipInfo.uuid" class="common_excel_no_more">暂无内容~</div>
        </div>
      </div>
      <div class="tab-view">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="从业人员" name="1"></el-tab-pane>
          <el-tab-pane label="项目负责人" name="2"></el-tab-pane>
          <el-tab-pane label="表彰信息" name="3"></el-tab-pane>
        </el-tabs>
        <el-table
          :cell-style="{ padding: '8px', transition: 'all 0.3s' }"
          :data="dataList"
          :header-cell-style="{
            lineHeight: '35px',
            height: '35px',
            padding: 0,
            backgroundColor: '#49b3ff',
            color: '#515a6e',
          }"
          stripe
          style="width: 100%"
          @row-click="rowClick"
        >
          <el-table-column
            align="center"
            label="姓名"
            prop="name"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{
                activeName == "1"
                  ? scope.row.name
                  : activeName === "2"
                    ? scope.row.certName
                    : scope.row.name
              }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="证书编号"
            prop="certno"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{
                activeName == "1"
                  ? scope.row.certno
                  : activeName === "2"
                    ? scope.row.certNo
                    : scope.row.certno
              }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="证书有效期"
            prop="yxqz"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
        <Page
          v-if="dataList.length != 0"
          :current="pageParams.pageNo"
          :page-size="pageParams.pageSize"
          :total="total"
          class="common_page_box"
          show-total
          @on-change="changePage"
        ></Page>
      </div>
    </div>
    <footerBox></footerBox>
    <Back-top :bottom="120" :height="100">
      <div class="iconfont icon-shangjiantou"></div>
    </Back-top>
  </div>
</template>

<script>
import bannerBox from "@/components/banner.vue";
import headerBox from "@/components/header.vue";
import footerBox from "@/components/footer.vue";
import {
  getCompanyCyrys,
  getCyry,
  getDetatilArticle,
  getXmfzr,
} from "@/api/home/index";
import { getVipInfo } from "@/api/home/index";
import { courseList } from "@/api/home/guild";
export default {
  name: "vipInfo",
  components: {
    bannerBox,
    headerBox,
    footerBox,
  },
  data() {
    return {
      vipInfo: {},
      params: {
        id: 0,
      },
      tabList1: [
        {
          label: "会长单位",
          value: 1,
        },
        {
          label: "副会长单位",
          value: 2,
        },
        {
          label: "监事单位",
          value: 3,
        },
        {
          label: "常务理事单位",
          value: 4,
        },
        {
          label: "副秘书长",
          value: 5,
        },
        {
          label: "理事单位",
          value: 6,
        },
        {
          label: "会员单位",
          value: 7,
        },
        {
          label: "监事长",
          value: 29,
        },
      ],
      activeName: "1",
      dataList: [],
      total: 0,
      pageParams: {
        pageNo: 1,
        pageSize: 10,
      },
    };
  },
  mounted() {
    this.params.id = Number(this.$route.query.id);
    this.getVipInfo();
  },
  methods: {
    /* ====================数据请求部分========================== */
    getVipInfo() {
      getVipInfo({
        ...this.params,
      }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          this.vipInfo = res.result;
          let item = this.tabList1.find((d) => d.value == this.vipInfo.type);
          this.vipInfo.type = item.label;
          this.getListData();
        } else {
          this.vipInfo = {};
        }
      });
    },
    handleClick(val) {
      console.log("val", val.name, this.activeName);
      if (val.name == "3") {
        this.$router.push({
          path: "/industryCredit",
          query: { dwmc: this.vipInfo.dwmc },
        });
        return;
      } else {
        this.params.pageNo = 1;
        this.getListData();
      }
    },
    rowClick(row) {
      if (this.activeName == "1") {
        this.$router.push({
          path: "/people_detail",
          query: { certno: row.certno },
        });
      }
    },
    changePage(e) {
      this.params.pageNo = e;
      this.getListData();
    },
    getListData() {
      if (this.activeName == "1") {
        // 从业人员
        getCyry({ ...this.params, dw: this.vipInfo.dwmc }).then((res) => {
          if (res.code == 200 || res.code == 0) {
            let info = res.result.records;
            this.dataList = info;
            this.total = res.result.total;
          }
        });
      }
      if (this.activeName == "2") {
        getXmfzr({ ...this.params, certCompany: this.vipInfo.dwmc }).then(
          (res) => {
            if (res.code == 200 || res.code == 0) {
              let info = res.result.records;
              this.dataList = info;
              this.total = res.result.total;
            }
          },
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content_box {
  margin: 80px 200px;

  .content_box2 {
    background-color: #c6ddf4;
    border-color: #e3e5e8;
    border-radius: 15px;
    padding: 80px;
  }

  .common_info {
    margin: 20px;
    .info_left {
      width: 68%;
      float: left;
    }

    .info_right {
      width: 26%;
      float: right;
    }
  }
  /* 自定义行悬停效果 */
  ::v-deep .el-table__body tr:hover > td {
    background-color: #fff5e6 !important;
    position: relative;
    cursor: pointer;
  }

  /* 悬停时添加右侧边框 */
  ::v-deep .el-table__body tr:hover > td:last-child::after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: #ff9a4d;
  }
}
</style>
